import { render, staticRenderFns } from "./NoterSenediAlacakForm.vue?vue&type=template&id=3afc25de"
import script from "./NoterSenediAlacakForm.vue?vue&type=script&lang=ts"
export * from "./NoterSenediAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports